export const trackEvent = async (type, value = '') => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const attributionSource = urlParams.get('loc') || urlParams.get('source') || '';

        await fetch('/api/analytics/track/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                event_type: type,
                event_value: value,
                attribution_source: attributionSource,
                screen_resolution: `${window.screen.width}x${window.screen.height}`,
                path: window.location.pathname,
            }),
        });
    } catch (error) {
        console.error('Analytics error:', error);
    }
};
